// extracted by mini-css-extract-plugin
export default {"alreadyRegisteredLink":"alreadyRegisteredLink___4MCL","header":"header__u3SQP","form":"form__wOtwm","oneClick":"oneClick__gOmVP"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"alreadyRegisteredLink\":\"alreadyRegisteredLink___4MCL\",\"header\":\"header__u3SQP\",\"form\":\"form__wOtwm\",\"oneClick\":\"oneClick__gOmVP\"}";
        // 1787130556859
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  